import { useTranslation } from 'react-i18next'
import { allowanceForUser } from '../../../../lib/Calculator'
import { UserType } from '../../../../lib/Enums/UserType'
import Headline from '../../../Elements/Headline'
import Text from '../../../Elements/Text'
import { useBudget } from '../../lib/Hooks/Budget'
import { useExpenses } from '../../lib/Hooks/Spends'

const BalancedAllowanceHelpText = () => {
  const { t } = useTranslation(['budget'])
  const { data: budget } = useBudget()
  const { data: spends } = useExpenses(budget!)

  const allowanceForAuthor = allowanceForUser(
    spends!,
    UserType.PRIMARY,
    budget!.author.data.salary!,
  )
  const allowanceForOtherUser = allowanceForUser(
    spends!,
    UserType.SECONDARY,
    budget!.user!.data.salary!,
  )

  if (allowanceForAuthor === allowanceForOtherUser) {
    return null
  }

  return (
    <>
      <Headline className='mb-2 font-bold' size='base'>
        {t('budget:balancedAllowanceHelpText.title')}
      </Headline>
      <Text className='mb-2'>
        {t('budget:balancedAllowanceHelpText.description1')}
      </Text>
      <Text className='mb-5'>
        {t('budget:balancedAllowanceHelpText.description2')}
      </Text>
    </>
  )
}

export default BalancedAllowanceHelpText
